import { render, staticRenderFns } from "./FileUploadDialog.vue?vue&type=template&id=2befff52"
import script from "./FileUploadDialog.vue?vue&type=script&lang=js"
export * from "./FileUploadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports